'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Divider-module_hr__Ej0Np{border:none;border-bottom:1px solid #e0e0e0}";
var styles = {"hr":"Divider-module_hr__Ej0Np"};
styleInject["default"](css_248z, 'fa81743c-7e40-4a65-9831-d0b18da7ad63');

exports["default"] = styles;
